"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuItemRadioClassNames: function() {
        return menuItemRadioClassNames;
    },
    useMenuItemRadioStyles_unstable: function() {
        return useMenuItemRadioStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _index = require("../../selectable/index");
const _useMenuItemStylesstyles = require("../MenuItem/useMenuItemStyles.styles");
const menuItemRadioClassNames = {
    root: 'fui-MenuItemRadio',
    icon: 'fui-MenuItemRadio__icon',
    checkmark: 'fui-MenuItemRadio__checkmark',
    content: 'fui-MenuItemRadio__content',
    secondaryContent: 'fui-MenuItemRadio__secondaryContent'
};
const useMenuItemRadioStyles_unstable = (state)=>{
    state.root.className = (0, _react.mergeClasses)(menuItemRadioClassNames.root, state.root.className);
    if (state.content) {
        state.content.className = (0, _react.mergeClasses)(menuItemRadioClassNames.content, state.content.className);
    }
    if (state.secondaryContent) {
        state.secondaryContent.className = (0, _react.mergeClasses)(menuItemRadioClassNames.secondaryContent, state.secondaryContent.className);
    }
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(menuItemRadioClassNames.icon, state.icon.className);
    }
    if (state.checkmark) {
        state.checkmark.className = (0, _react.mergeClasses)(menuItemRadioClassNames.checkmark, state.checkmark.className);
    }
    (0, _useMenuItemStylesstyles.useMenuItemStyles_unstable)(state);
    (0, _index.useCheckmarkStyles_unstable)(state);
}; //# sourceMappingURL=useMenuItemRadioStyles.styles.js.map
